(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('accordion-read-more')) {
    customElements.define('accordion-read-more', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const button = this.querySelector('.accordion-read-more__button');
        if (!button) return;
        this.initialized = true;

        const overflowHeaders = this.querySelectorAll('[data-accordion-overflow]');
        overflowHeaders.forEach((header) => { header.hidden = true; });
        button.hidden = false;

        const reveal = (moveFocus) => {
          overflowHeaders.forEach((header) => {
            header.hidden = false;
            header.removeAttribute('data-aos');
            header.removeAttribute('data-aos-delay');
          });
          button.setAttribute('aria-expanded', 'true');
          button.hidden = true;
          if (moveFocus) overflowHeaders[0].focus({ preventScroll: true });
        };

        button.addEventListener('click', () => reveal(true));
        this.addEventListener('shopify:block:select', () => reveal(false));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
